    /**
     * Ajax utilities.
     * Defines the central Ajax object and all window.Ajax.* convenience methods.
     * Assigned to window so all page-level templates can call them without importing.
     *
     * PRIME_BASE_URL should point to your prime backend.
     * In development this is typically your local WP install;
     * in production it should be the live admin domain.
     */

    /**
     * Local testing override for the Prime backend, WITHOUT touching production
     * behavior: append ?prime_backend=services to the page URL, or run
     * localStorage.setItem('nth_prime_backend', 'services') once in devtools, to
     * point prime_v2/mergeMatches at the new services/ layer on THIS site's own
     * domain. With no override present, behavior is byte-for-byte what it always
     * was — admin.topphandball.no + apps/prime/. Safe to leave in place even
     * after a real deploy; nobody flips this by accident.
     *
     * Remove this override (and the two "apps/prime/" fallback branches below)
     * once services/ fully replaces apps/prime/ in production.
     */
    function primeUsesServicesBackend() {
        try {
            if (new URLSearchParams(window.location.search).get('prime_backend') === 'services') {
                return true;
            }
            return window.localStorage.getItem('nth_prime_backend') === 'services';
        } catch (e) {
            return false;
        }
    }

    const PRIME_USES_SERVICES_BACKEND = primeUsesServicesBackend();

    // No manual swap needed before deploying — defaults to the production admin
    // domain unless the local-testing override above is explicitly set.
    const PRIME_BASE_URL = PRIME_USES_SERVICES_BACKEND
        ? window.location.origin + '/'
        : 'https://admin.topphandball.no/';

    const PRIME_PATH = PRIME_USES_SERVICES_BACKEND ? 'services/prime/' : 'apps/prime/';

    const Ajax = {
    token: '',
    url: '/wp-content/themes/nth-5.3/resources/ajax.php',

    execute(payload, success, failure, timeout = 12000) {
        let contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        let processData = true;
        let cache       = true;
        const async     = payload.async === false ? false : true;

        if (payload.data instanceof FormData) {
            processData = false;
            cache       = false;
            contentType = false;

            payload.data.append('class',  payload.class);
            payload.data.append('method', payload.method);
            payload.data.append('json',   JSON.stringify(payload.param));
            payload = payload.data;
        } else {
            payload.token = Ajax.token;
        }

        $.ajax({
            type       : 'POST',
            url        : Ajax.url,
            contentType: contentType,
            processData: processData,
            cache      : cache,
            data       : payload,
            async      : async,
            timeout    : timeout,
            success(data) {
                if (data.result === 'success') {
                if (success instanceof Function) success(data);
                } else {
                if (failure instanceof Function) failure(data);
                }
            },
            error() {},
        });
    },
    };

    // ─── prime_v2 ───────────────────────────────────────────────────────────────

    Ajax.prime_v2 = function(oTheJson, success, failure) {
        /*eslint-disable */
        const sTheAdminSettings = JSON.stringify(ADMIN_SETTINGS);
        /*eslint-disable */
        const sTheSiteSettings  = JSON.stringify(SITE_SETTINGS);

        oTheJson.admin_settings = sTheAdminSettings;
        oTheJson.site_settings  = sTheSiteSettings;

        // Temporary debug aid: when pointed at the local services/ backend,
        // ask prime.php to return the real exception (class/message/file/
        // line/trace) instead of a blank 500 — see the debug=1 handling in
        // services/prime/prime.php. Tied to PRIME_USES_SERVICES_BACKEND so
        // it can never fire against production. Response still logs via
        // the console.log(data) below even on failure, so it's visible
        // without extra devtools setup.
        if (PRIME_USES_SERVICES_BACKEND) {
            oTheJson.debug = 1;
        }

        $.ajax({
            type       : 'POST',
            url        : PRIME_BASE_URL + PRIME_PATH + 'prime.php',
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            processData: true,
            cache      : true,
            data       : oTheJson,
            async      : true,
            timeout    : 120000,
            success(data) {

                console.log(data);

                // jQuery auto-parses the response into an object when the
                // server declares Content-Type: application/json (the
                // services/prime/ port does; the legacy apps/prime/ endpoint
                // doesn't) — only parse manually when it's still a raw
                // string, so this works against both.
                if (typeof data === 'string') {
                    data = JSON.parse(data);
                }
                if (data.result === 'success') {
                    if (success instanceof Function) success(data);
                } else {
                    if (failure instanceof Function) failure(data);
                }
            },
            error(xhr, status) {
                console.log('Ajax.prime_v2 request failed', xhr.status, status, xhr.responseText);
            },
        });
    };

    // ─── mergeMatches ───────────────────────────────────────────────────────────

    Ajax.mergeMatches = function(oTheJson, success, failure) {
        /*eslint-disable */
        const sTheAdminSettings = JSON.stringify(ADMIN_SETTINGS);
        const sTheSiteSettings  = JSON.stringify(SITE_SETTINGS);

        oTheJson.admin_settings = sTheAdminSettings;
        oTheJson.site_settings  = sTheSiteSettings;

        // Same temporary debug aid as Ajax.prime_v2 — see services/prime/merge.php.
        if (PRIME_USES_SERVICES_BACKEND) {
            oTheJson.debug = 1;
        }

        $.ajax({
            type       : 'POST',
            url        : PRIME_BASE_URL + PRIME_PATH + 'merge.php',
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            processData: true,
            cache      : true,
            data       : oTheJson,
            async      : true,
            timeout    : 120000,
            success(data) {
            // Same jQuery auto-parse defensiveness as Ajax.prime_v2.
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            if (data.result !== 'success') console.log(data);
            if (data.result === 'success') {
                if (success instanceof Function) success(data);
            } else {
                if (failure instanceof Function) failure(data);
            }
            },
            error(xhr, status) {
                console.log('Ajax.mergeMatches request failed', xhr.status, status, xhr.responseText);
            },
        });
    };

    // ─── Convenience wrappers ───────────────────────────────────────────────────

    Ajax.frontpage_articles = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'frontpage_articles', param: sTheJson }, success, failure);
    };

    Ajax.getNthData = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'get_nth_data', param: sTheJson }, success, failure);
    };

    Ajax.getPosts = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'posts', param: sTheJson }, success, failure);
    };

    Ajax.importPosts = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'import', param: sTheJson }, success, failure);
    };

    Ajax.convertPosts = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'convert', param: sTheJson }, success, failure);
    };

    Ajax.getBroadcastData = function(sTheJson, success, failure) {
        Ajax.execute({ class: 'generate', method: 'getBroadcastData', param: sTheJson }, success, failure);
    };

    // ─── Shared error handler ───────────────────────────────────────────────────

    function showError(data) {
    // TODO: surface errors meaningfully in the UI
    }

    export function initAjax() {
    window.Ajax      = Ajax;
    window.showError = showError;

    // Loader HTML — used by multiple modules when showing loading state
    window.sTheLoader = '<div class="loaderinfo d-flex justify-content-center align-items-center flex-row">'
        + '<div class="loadingio-spinner-spinner-nq4q5u6dq7r"><div class="ldio-x2uulkbinc">'
        + '<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>'
        + '</div></div>'
        + '<span class="d-block mt-2">Laster innhold – vennligst vent...</span></div>';
    }



// WEBPACK FOOTER //
// ./scripts/routes/common/ajax.js